<template>
<div class="chapter">
<div class="inner_page">
<p class="GillSans" style="text-align:center"><span class="GillSans-Bold">Other Close to Home Books by John McPherson</span></p>
<p class="GillSans" style="text-align:center">Close to Home<br/>
One Step Closer to Home<br/>
Dangerously Close to Home<br/>
Home: The Final Frontier<br/>
The Honeymoon Is Over<br/>
The Silence of the Lamberts<br/>
Striking Close to Home<br/>
The Close to Home Survival Guide<br/>
</p>
<p class="GillSans" style="text-align:center"><span class="GillSans-Bold">Treasury Collections</span><br/>
Close to Home Revisited<br/> Close to Home Unplugged</p>
<p class="GillSans" style="text-align:center"><span class="GillSans-Bold">Also from John McPherson</span><br/>
High School Isn’t Pretty<br/>
Close to Home: A Book of Postcards<br/>
The Barber of Bingo<br/>
The Get Well Book</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// CTH_03.vue?54e653f6